<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.2272 12.1414C15.3053 12.0633 15.3053 11.9366 15.2272 11.8585L8.93427 5.56564C8.62185 5.25322 8.62185 4.74668 8.93427 4.43427C9.24669 4.12185 9.75322 4.12185 10.0656 4.43427L16.3585 10.7272C17.0615 11.4301 17.0615 12.5698 16.3585 13.2727L10.0656 19.5656C9.75322 19.8781 9.24669 19.8781 8.93427 19.5656C8.62185 19.2532 8.62185 18.7467 8.93427 18.4343L15.2272 12.1414Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
